import { Injectable } from '@angular/core';

import { isDatasetLinkValue } from '@blaze-shared/schema-domain';

@Injectable({ providedIn: 'root' })
export class IntelliDataService {
  getNestedValueFromInput(input: any, keys: string[], matchValue: any): any {
    if (!keys?.length) {
      return matchValue;
    }

    let value: any;
    keys.forEach((key) => {
      if (!!input && key in input) {
        value = isDatasetLinkValue(input[key]) ? input[key]?.rowId || '' : input[key];
        input = value;
      }
    });
    return isDatasetLinkValue(input) ? input['rowId'] : value;
  }
}
